// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"829f0c1d31619953","7229":"eed2072bf61581bf"}[chunkId] + ".js";
};